import {
  PresenceAvailabilityMenu,
  PresenceStatusMessageEditor,
} from "@bezoned/shared/components/presence/presence-control-popover-content.jsx";
import { usePresenceControlPopover } from "@bezoned/shared/hooks/use-presence-control-popover.js";
import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { UserAvailability } from "@bezoned/shared/types/user-presence.js";
import {
  Popover,
  PopoverSurface,
  PopoverTrigger,
  PresenceBadge,
} from "@fluentui/react-components";
import type { PresenceBadgeStatus } from "@fluentui/react-components";

import { useFluid } from "../../fluid/hooks/use-fluid.js";
import { useMyPresence } from "../use-my-presence.js";
import { useUserPresence } from "../use-user-presence.js";

export const PresenceControl = () => {
  const { statusMessage, updateAvailability, updateStatusMessage } =
    useMyPresence();
  const { fluidUserId } = useFluid();
  const presence = useUserPresence({ msUserId: fluidUserId });
  const availability = presence?.availability ?? "offline";
  const isOutOfOffice = presence?.outOfOffice?.isOutOfOffice ?? false;
  const {
    isOpen,
    popoverVariant,
    newStatusMessage,
    setNewStatusMessage,
    setPopoverVariant,
    handleAvailabilityChange,
    handleStatusMessageSubmit,
    handleOpenChange,
  } = usePresenceControlPopover({
    onAvailabilityChange: (newAvailability: UserAvailability) =>
      updateAvailability(newAvailability),
    onStatusMessageSave: (nextStatusMessage: string | null) =>
      updateStatusMessage(nextStatusMessage),
    statusMessage,
  });
  const handleStatusMessageChangeRequest70 = useStableCallback(() =>
    setPopoverVariant("statusMessage")
  );
  const handleClick67 = useStableCallback((event) => event.stopPropagation());

  const handleOpenChange47 = useStableCallback((_event, data) => {
    handleOpenChange(data.open);
  });

  return (
    <Popover onOpenChange={handleOpenChange47} open={isOpen}>
      <PopoverTrigger disableButtonEnhancement>
        <span className="flex cursor-pointer flex-col items-center select-none">
          <PresenceBadge
            className="h-7.5"
            outOfOffice={isOutOfOffice}
            size="large"
            // ? There should be enough overlap, but we are missing "blocked" state, which is not clear how to get from the API values.
            status={availability as PresenceBadgeStatus}
          />
          Status
        </span>
      </PopoverTrigger>

      <PopoverSurface
        data-blocks-hover="true"
        onClick={handleClick67}
        tabIndex={-1}
      >
        {popoverVariant === "availability" ? (
          <PresenceAvailabilityMenu
            isOutOfOffice={isOutOfOffice}
            onAvailabilityChange={handleAvailabilityChange}
            onStatusMessageChangeRequest={handleStatusMessageChangeRequest70}
          />
        ) : (
          <PresenceStatusMessageEditor
            onStatusMessageChange={setNewStatusMessage}
            onStatusMessageSubmit={handleStatusMessageSubmit}
            value={newStatusMessage}
          />
        )}
      </PopoverSurface>
    </Popover>
  );
};
